<script setup lang="ts">
  import { computed, PropType } from 'vue'
  import type { OptionItemI } from '@/typescript/types/ui-components/SelectItem'

  const props = defineProps({
    modelValue: {
      type: [String, Number],
      default: null,
    },
    optionList: {
      type: Array as PropType<OptionItemI[]>,
      default: () => [],
    },
  })
  const emit = defineEmits(['update:modelValue'])
  const selectModelValue = computed({
    get() {
      return props.modelValue
    },
    set(newValue) {
      emit('update:modelValue', newValue)
    },
  })
</script>
<template>
  <select v-model="selectModelValue" class="styled-select">
    <option v-for="option in optionList" :key="option.value" :value="option.value">
      {{ option.title }}
    </option>
  </select>
</template>
<style scoped>
  .styled-select {
    border-radius: 7px;
    border: 1px solid var(--bf-line);
    padding: 0 30px 0 12px;
    height: 36px;
    outline: none;
  }
</style>
